/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Notifications_TitleInputs */

const he_hero_notifications_title = /** @type {(inputs: Hero_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות ירידת מחיר וחזרה למלאי`)
};

const en_hero_notifications_title = /** @type {(inputs: Hero_Notifications_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drop & back-in-stock alerts`)
};

/**
* | output |
* | --- |
* | "Price drop & back-in-stock alerts" |
*
* @param {Hero_Notifications_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_notifications_title = /** @type {((inputs?: Hero_Notifications_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Notifications_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_notifications_title(inputs)
	return en_hero_notifications_title(inputs)
});